<template>
  <div />
</template>

<script>
import { useHead } from '@unhead/vue';
import axios from 'axios';
import { mapActions } from 'pinia';

import useAuth from '@/composables/useAuth';
import useHasSmartOnboardingAccess from '@/composables/useHasSmartOnboardingAccess';
import { captureException } from '@/errors';
import { ls } from '@/local_storage';
import { useFlashesStore, usePartnersStore } from '@/stores';
import urls from '@/urls';
export default {
  name: 'PublicInvite',
  components: {},

  setup() {
    useHead({
      title: 'Invite - Crossbeam',
      meta: [
        {
          name: 'robots',
          content: 'noindex nofollow',
        },
      ],
    });
    const { currentOrg, isLoggedIn } = useAuth();
    const isSmartOnboarding = useHasSmartOnboardingAccess();

    return { currentOrg, isLoggedIn, isSmartOnboarding };
  },

  data() {
    return {
      fromOrganizationName: null,
      publicInviteOrg: null,
    };
  },
  computed: {
    publicInviteCode() {
      return this.$route.params.code;
    },
    hasCompletedExtraStep() {
      const orgId = this.currentOrg?.id;
      if (!orgId) return false;
      return (
        ls.acceptedInviteSender.get()?.orgId === orgId ||
        ls.publicInviteSentOrg.get()?.orgId === orgId
      );
    },
  },
  async created() {
    if (this.publicInviteCode) {
      try {
        const publicInviteUrl = urls.publicInviteCode.getOrgId(
          this.publicInviteCode,
        );
        const response = await axios.get(publicInviteUrl);
        if (response.data) {
          this.publicInviteOrg = response.data;
          ls.publicInvite.set({
            code: this.publicInviteCode,
            org: response.data,
          });
          const { from } = this.$route.query;
          const basePath = this.currentOrg.setup_menu_hidden
            ? '/partners'
            : '/onboarding';
          if (!this.isLoggedIn) {
            this.$router.push({
              path: '/register',
              query: { public_invite_code: this.publicInviteCode },
            });
          } else if (
            this.currentOrg.public_invite_code === this.publicInviteCode
          ) {
            ls.publicInvite.set();
            if (from === 'home') {
              this.$router.push({ name: from });
              this.addErrorFlash({
                message: 'You tried to scan your own QR Code',
              });
            } else {
              this.$router.push({
                path: basePath,
              });
            }
          } else if (
            !this.currentOrg.setup_menu_hidden &&
            this.isSmartOnboarding &&
            !this.hasCompletedExtraStep
          ) {
            this.setPublicInviteOrg(response.data);
            this.setPublicInviteCode(this.publicInviteCode);
            this.$router.push({ path: '/onboarding' });
          } else {
            const nextRoute = {
              path: `${basePath}/public-invite`,
            };
            if (from === 'home') {
              nextRoute.query = {
                from,
              };
            }
            this.$router.push(nextRoute);
          }
        }
      } catch (error) {
        if (!this.isLoggedIn) {
          this.$router.push({ path: '/register' });
        } else {
          this.$router.push({
            path: this.currentOrg?.setup_menu_hidden
              ? '/partners'
              : '/onboarding',
          });
        }
        captureException(error);
        this.publicInviteOrg = null;
      }
    }
  },
  methods: {
    ...mapActions(useFlashesStore, ['addErrorFlash']),
    ...mapActions(usePartnersStore, [
      'setPublicInviteCode',
      'setPublicInviteOrg',
    ]),
  },
};
</script>
